import styled from 'styled-components'

import {Link as BaseLink} from '@/src/shared/ui/link'

export const Wrapper = styled.div`
  max-width: 195px;
  width: 100%;
  display: flex;
  justify-content: center;
`

export const Link = styled(BaseLink)`
  display: flex;
  align-items: center;

  & img {
    max-width: 145px;
    height: auto;
  }
`
